import React from 'react';
import { LoadingSpinner } from './LoadingSpinner';
import { COMMON_CLASSES, SIZE_CLASSES } from '@/styles/classes';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  loading?: boolean;
  children: React.ReactNode;
}

export const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'md',
  loading = false,
  children,
  className = '',
  disabled,
  ...props
}) => {
  const variantClasses = {
    primary: COMMON_CLASSES.buttonPrimary,
    secondary: COMMON_CLASSES.buttonSecondary,
    danger: COMMON_CLASSES.buttonDanger,
    ghost: COMMON_CLASSES.buttonGhost,
  };

  const classes = `${COMMON_CLASSES.button} ${variantClasses[variant]} ${SIZE_CLASSES.button[size]} ${className}`;

  return (
    <button type="button" className={classes} disabled={disabled || loading} {...props}>
      {loading && <LoadingSpinner size="sm" className="mr-2" />}
      {children}
    </button>
  );
};
